/**
 * @generated SignedSource<<f9ec7f746c7b850dde2964828d176de6>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GetHelpZendeskPromotedArticles_viewer$data = {
  readonly zendeskArticles: {
    readonly promotedArticles: ReadonlyArray<{
      readonly serviceId: string | null;
      readonly title: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "GetHelpZendeskPromotedArticles_viewer";
};
export type GetHelpZendeskPromotedArticles_viewer$key = {
  readonly " $data"?: GetHelpZendeskPromotedArticles_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"GetHelpZendeskPromotedArticles_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isCheckout"
    },
    {
      "kind": "RootArgument",
      "name": "isSeller"
    },
    {
      "kind": "RootArgument",
      "name": "sellerId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "GetHelpZendeskPromotedArticles_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "isSeller",
          "variableName": "isSeller"
        },
        {
          "kind": "Variable",
          "name": "sellerId",
          "variableName": "sellerId"
        }
      ],
      "concreteType": "Contact1stdibsZendeskArticles",
      "kind": "LinkedField",
      "name": "zendeskArticles",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "isCheckout",
              "variableName": "isCheckout"
            }
          ],
          "concreteType": "ZendeskArticle",
          "kind": "LinkedField",
          "name": "promotedArticles",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "acbae31c61684441d1b612f5d9f23442";

export default node;
